import { GP_TYPE } from '@lmc/ts-common'
import { ID } from '../utils'
import { Route } from 'react-router-dom'
import { ResidentGPConnectScreen } from 'screens/Residents/screens/ResidentProfileScreen/screens/GPConnectScreen/GPConnectScreen'

export const GPConnectRoutes = (
  <Route path={`${ID}/gp-connect`}>
    <Route
      path={GP_TYPE.SUM}
      element={<ResidentGPConnectScreen type={GP_TYPE.SUM} />}
    />
    <Route
      path={GP_TYPE.ENC}
      element={<ResidentGPConnectScreen type={GP_TYPE.ENC} />}
    />
    <Route
      path={GP_TYPE.CLI}
      element={<ResidentGPConnectScreen type={GP_TYPE.CLI} />}
    />
    <Route
      path={GP_TYPE.PRB}
      element={<ResidentGPConnectScreen type={GP_TYPE.PRB} />}
    />
    <Route
      path={GP_TYPE.ALL}
      element={<ResidentGPConnectScreen type={GP_TYPE.ALL} />}
    />
    <Route
      path={GP_TYPE.MED}
      element={<ResidentGPConnectScreen type={GP_TYPE.MED} />}
    />
    <Route
      path={GP_TYPE.REF}
      element={<ResidentGPConnectScreen type={GP_TYPE.REF} />}
    />
    <Route
      path={GP_TYPE.OBS}
      element={<ResidentGPConnectScreen type={GP_TYPE.OBS} />}
    />
    <Route
      path={GP_TYPE.IMM}
      element={<ResidentGPConnectScreen type={GP_TYPE.IMM} />}
    />
    <Route
      path={GP_TYPE.ADM}
      element={<ResidentGPConnectScreen type={GP_TYPE.ADM} />}
    />
  </Route>
)
